"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormReportStore from "Stores/Forms/FormReportStore";
import { System } from "Constants/objects";
import { Messages } from "Messages";
import { formReportApply, formReportInitialize, formReportNavigateToParent } from "Actions/Forms/FormReportActions";

var styles = function styles(theme) {
  return {
    formHeight: {
      height: 'calc(100% - 64px)'
    },
    formButtonsPanel: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: '20px'
    },
    formFilterButtons: {
      margin: theme.spacing.unit
    }
  };
};

var FormReport =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormReport, _React$Component);

  function FormReport(props) {
    var _this;

    _classCallCheck(this, FormReport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormReport).call(this, props));
    _this._onChange = _this._onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = FormReportStore.getInitList();
    return _this;
  }

  _createClass(FormReport, [{
    key: "_onChange",
    value: function _onChange() {
      this.setState(FormReportStore.getList(this.props.UUID));
    }
  }, {
    key: "_onCancelClick",
    value: function _onCancelClick() {
      formReportNavigateToParent(this.props.UUID);
    }
  }, {
    key: "_onApplyClick",
    value: function _onApplyClick() {
      formReportApply(this.props.UUID);
    }
  }, {
    key: "initForm",
    value: function initForm() {
      var _this2 = this;

      $(this.scrollView).dxScrollView({
        height: 'calc(100% + 20px)',
        width: '100%',
        elementAttr: {
          id: "fscrl-".concat(this.props.UUID)
        },
        scrollByContent: true,
        scrollByThumb: true,
        showScrollbar: "always"
      });
      this.instanceForm = this.formEl;
      this.initOwner();
      var instances = {
        form: this.instanceForm,
        popup: this.popupInstance
      };
      setTimeout(function () {
        return formReportInitialize(_this2.props.formObj, instances);
      });
    }
  }, {
    key: "initOwner",
    value: function initOwner() {
      var that = this;
      var title = this.props.formObj.title;
      var UUID = this.props.UUID;
      var caption = title || '';
      this.popupInstance = this.$popupEl.dxPopup({
        dragEnabled: true,
        showTitle: true,
        tabIndex: -1,
        closeOnOutsideClick: false,
        width: 'auto',
        height: 'auto',
        maxHeight: '100%',
        maxWidth: '100%',
        minHeight: '300px',
        minWidth: '500px',
        position: {
          my: 'center',
          at: 'center',
          of: 'body'
        },
        onShown: function onShown(e) {
          $("#fscrl-".concat(UUID)).find('.dx-scrollable-container').attr('tabIndex', -1);
        },
        contentTemplate: function contentTemplate(container) {
          container.append(that.scrollView);
          return container.append(that.scrollView);
        },
        onHidden: function onHidden() {
          $('.d5-popover').remove();
          formReportNavigateToParent(UUID);
        },
        titleTemplate: function titleTemplate(titleElement) {
          titleElement.append("<div class='form-title' ><span id=\"fe-title-".concat(UUID, "\">").concat(caption, "</span><div/>"));
          titleElement.find('.form-title').append(that.createButtonPanel());
          return titleElement;
        }
      });
    }
  }, {
    key: "createButtonPanel",
    value: function createButtonPanel() {
      if (this.props.formObj.viewMode === System.VIEW_MODE.MODAL) {
        var apply = $("<div class=\"title-button\"  tabIndex=\"-1\">".concat(Messages.Controls.Apply, "</div>"));
        var cancel = $("<div class=\"title-button\"  tabIndex=\"-1\">".concat(Messages.Controls.Cancel, "</div>"));
        apply.on('click', this._onApplyClick.bind(this));
        cancel.on('click', this._onCancelClick.bind(this));
        return $("<div class=\"form-buttons-panel\"/>").append(apply).append(cancel);
      } else {
        var buttonsProps = {
          apply: {
            className: "title-button",
            tabIndex: -1,
            onClick: this._onApplyClick.bind(this),
            key: "sbtb-1"
          },
          cancel: {
            className: "title-button",
            onClick: this._onCancelClick.bind(this),
            key: "cbtb-1",
            tabIndex: -1
          }
        };

        var _apply = React.createElement('div', buttonsProps.apply, Messages.Controls.Apply);

        var _cancel = React.createElement('div', buttonsProps.cancel, Messages.Controls.Cancel);

        return React.createElement('div', {
          className: "form-buttons-panel"
        }, [_apply, _cancel]);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      FormReportStore.addChangeListener(this._onChange);
      this.initForm();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      FormReportStore.removeChangeListener(this._onChange);
      if (this.popupInstance) this.popupInstance.remove();
      FormReportStore.destroy(this.props.UUID);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var formObj = this.props.formObj;
      return React.createElement("div", {
        style: {
          height: '100%',
          padding: '16px'
        }
      }, React.createElement("div", {
        ref: function ref(r) {
          return _this3.$popupEl = $(r);
        },
        style: {
          height: '100%',
          backgroundColor: '#ffffff'
        }
      }, React.createElement("div", {
        className: "scroll-view",
        ref: function ref(r) {
          return _this3.scrollView = r;
        }
      }, React.createElement("div", {
        id: "report-from-".concat(formObj.formID),
        className: 'form',
        ref: function ref(r) {
          return _this3.formEl = r;
        },
        style: {
          padding: '20px'
        }
      }))));
    }
  }]);

  return FormReport;
}(React.Component);

_defineProperty(FormReport, "propTypes", {
  classes: PropTypes.object.isRequired,
  UUID: PropTypes.string.isRequired,
  isActive: PropTypes.bool
});

_defineProperty(FormReport, "defaultProps", {
  formID: "".concat(Math.floor(Math.random() * 1000)),
  isActive: false
});

export default withStyles(styles)(FormReport);